<template>
  <div id="perfect-info-layer">
    <e-header :stitle="stitle"></e-header>
    <div class="perfect-info-content">
      <h3 class="perfect-info-title">完善信息</h3>
      <p class="perfect-info-text">账号名：{{userInfo.userName}}</p>
      <p class="perfect-info-text">绑定手机号：{{userInfo.phone}}</p>
      <p class="perfect-info-text" v-show="!userInfo.email">绑定邮箱：您还可以 <router-link to="/bind-email" style="color: #FF0000">绑定邮箱</router-link>，即时获取专属信息。</p>
      <p class="perfect-info-text" v-show="userInfo.email">邮箱：{{userInfo.email}}</p>
      <p class="perfect-info-d">《中华人民共和国电子签名法》要求签署方身份真实，您还没有完成实名认证，此时签署的文件不具备法律效力。</p>
      <el-button type="primary" class="to-auto" @click="pensonalAuth">立即认证</el-button>
    </div>
  </div>
</template>
<script>
import eHeader from '@/components/eHeader'
import { mapState } from 'vuex'
export default {
  components: {
    eHeader
  },
  data() {
    return {
      stitle: '用户注册',
    }
  },
  computed: mapState([
    'userInfo'
  ]),
  methods: {
    pensonalAuth() {
      localStorage.removeItem('vuex');
      this.$router.push({ path: '/personal-auth-info'})
    }
  }
}
</script>
<style scoped>
  .perfect-info-content{
    width: 409px;
    margin: 141px auto 0;
  }

  .perfect-info-title{
    font-size: 24px;
    color: #333333;
    text-align: center;
    margin-bottom: 65px;
  }
  
  .perfect-info-text{
    font-size: 16px;
    color: #333333;
    margin-bottom: 25px;
  }

  .perfect-info-text span {
    color: #D75B58;
  }

  .perfect-info-d{
    color: #FF0000;
    font-size: 16px;
  }

  .to-auto{
    width: 409px;
    margin-top: 45px;
    height: 50px;
    font-size: 18px;
  }
</style>